import { useEffect, useState } from 'react'
import { StudentImage } from '../../../../models'
import useLocalStorage from "../../../../hooks/useLocalStorage";

export const usePoses = (studentId, packageIds = [], pastImages = false) => {
  const [data, setData] = useState({})
  const [error, setError] = useState()
  const [fetching, setFetching] = useState(true)
  const [currentSeason] = useLocalStorage(`currentSeason-${studentId}`)

  useEffect(() => {
    setFetching(true)
    const promises = packageIds.map((packageId) => (
      StudentImage
        .includes('poses')
        .where({ forPoses: [packageId, pastImages, currentSeason] })
        .where({ studentId })
        .all()
    ))

    Promise.all(promises).then((results) => {
      const temp = {}
      results.forEach((result, index) => {
        temp[packageIds[index]] = result.data.map((datum) => datum.poses).flat()
      })

      setData(temp)
      setFetching(false)
    })
  }, [studentId, JSON.stringify(packageIds)])

  return { data, error, fetching }
}
